import {
  CHECKOUT_SUBPATH,
  DELETE_PET_SUBPATH,
  INTRO_SLUG,
} from '../../routing';
import { STATE } from '../constants';

export const shouldSkipInterstitialFromPath = asPath =>
  asPath.includes(CHECKOUT_SUBPATH) || asPath.includes(DELETE_PET_SUBPATH);

export const shouldRenderPrefetchLoading = ({ propsComponent, stateKey }) =>
  propsComponent === 'redirect_route' || stateKey === STATE.initial;

export const resolvePrefetchLoadingVariant = ({ pathname, petName }) => {
  if (pathname === DELETE_PET_SUBPATH) {
    return { variant: 'deletePet', petName };
  }

  if (pathname === undefined || pathname === INTRO_SLUG) {
    return { variant: 'initial' };
  }

  return { variant: 'default' };
};

export const shouldShowPlanLoadingWhileResuming = ({
  stateKey,
  pathname,
  isLoading,
  skipInterstitial,
}) =>
  stateKey === STATE.recommendedPlan &&
  pathname === stateKey &&
  isLoading &&
  skipInterstitial;

export const shouldShowCrunchingNumbersInterstitial = ({
  stateKey,
  pathname,
  showPlanSelection,
  skipInterstitial,
}) =>
  stateKey === STATE.recommendedPlan &&
  pathname === stateKey &&
  !showPlanSelection &&
  !skipInterstitial;

export const shouldResetPlanInterstitial = ({
  stateKey,
  pathname,
  skipInterstitial,
  showPlanSelection,
}) =>
  stateKey === STATE.recommendedPlan &&
  pathname === stateKey &&
  !skipInterstitial &&
  !showPlanSelection;

export const isLegacyPupInfoRoute = key =>
  key === STATE.pupInfo || key === STATE.about;

export const buildRouteChangePayload = ({
  key,
  routerAsPath,
  pets,
  pet_id,
  pet,
  cart,
  customer,
  queryPetId,
}) => {
  if (isLegacyPupInfoRoute(key)) {
    const isNewPet = routerAsPath.includes(CHECKOUT_SUBPATH);

    return {
      pets,
      pet_id: isNewPet ? 'new_pet' : '',
      pet: {},
      cart,
      customer,
      personalizedPlan: false,
    };
  }

  return {
    pets,
    pet,
    pet_id: queryPetId ?? pet_id,
    cart,
    customer,
  };
};
